__turbopack_context__.v({
  "className": "stick_no_bills_467f1aaa-module__3ESCrW__className",
});
